import * as React from "react";
import { useNavigate } from "react-router-dom";
import SearchInput from "../../components/uiMerge/searchInput";
import SearchIcon from "../../assets/wallet/search-icon.png";
import { TemplateSub } from "../../components/layouts/TemplateSub";
import * as ROUTES from "../../constants/routes";
import { SearchUser, RecentBeneficiaries } from "@njoy/controller";

import PersonIcon from "../../assets/wallet/person-icon.png";
import AntAvatar from "../shared/AntAvatar";
import HouseIcon from "../../assets/wallet/house-icon.png";

export const SendMoneyPage: React.FC = () => {
  const [search, setSearch] = React.useState("");
  const [variables, setVariables] = React.useState({
    input: { searchText: "" },
    offset: 0,
    limit: 10,
  });
  const navigate = useNavigate();

  const handleSearch = (value: string) => {
    setSearch(value);
    setVariables({
      input: { searchText: value },
      offset: 0,
      limit: 10,
    });
  };

  return (
    <TemplateSub isCentered page={`Send Money`}>
      <div className="w-full flex-1 h-full overflow-y-auto pb-4">
        <div className="w-full flex-1 overflow-y-auto pb-7">
          {/* Search Input */}
          <div className="w-full px-[1rem] mt-6">
            <SearchInput
              prefixIcon={
                <img src={SearchIcon} alt="search" width={20} height={20} />
              }
              id="search"
              name="search"
              type="search"
              placeholder="Name, Username, Email, Mobile Number"
              value={search}
              onChange={(e) => handleSearch(e.target.value)}
              className=" px-5 flex justify-between items-center gap-5 mt-0"
              end2end={false}
            />
          </div>

          <SearchUser variables={variables}>
            {({ results, loading, loadMore, hasMoreResults }) => (
              <>
                {loading && (
                  <p className="text-white px-4 mt-4">Searching...</p>
                )}
                {results.length > 0 ? (
                  <div className="flex flex-col mt-8 gap-3 px-[1rem] ">
                    <p className="text-white text-[20px] text-left">
                      Search Results
                    </p>

                    {results.map((user) => (
                      <>
                        {user.__typename === "CustomerPWA" &&
                          <div
                            key={user.id}
                            onClick={() =>
                              navigate(
                                `${ROUTES.VIEW_SEND_INFO_DETAILS}?user=${user.id}`
                              )
                            }
                            className="flex w-full mt-1 items-center border-[#1d1d1d] justify-between gap-3 pb-3 border-b-2 cursor-pointer"
                          >
                            <div className="flex items-center gap-4">
                              <div className="w-[54px] h-[54px] rounded-full overflow-hidden">
                                <AntAvatar
                                  firstname={`${user.firstname}`}
                                  lastname={`${user.lastname}`}
                                  height="54px"
                                  width="54px"
                                  fontSize="20px"
                                  color="#D9D9D9"
                                />
                              </div>

                              <div className="flex flex-col gap-1">
                                <p className="text-[16px] text-white font-semibold">
                                  {user.firstname} {user.lastname}
                                </p>

                                <p className="text-[12px] text-[#777] ">
                                  {user.username}
                                </p>
                              </div>
                            </div>

                            <img src={PersonIcon} alt="" width={15} height={15} />
                          </div>
                        }

                        {user.__typename === "AdminPWA" &&
                          <div
                            key={user.id}
                            onClick={() =>
                              navigate(
                                `${ROUTES.VIEW_SEND_INFO_DETAILS}?user=${user.id}`
                              )
                            }
                            className="flex w-full mt-1 items-center border-[#1d1d1d] justify-between gap-3 pb-3 border-b-2 cursor-pointer"
                          >
                            <div className="flex items-center gap-4">
                              <div className="w-[54px] h-[54px] rounded-full overflow-hidden">
                                {user.merchantProfile?.logoUrl ? (
                                    <img
                                      src={user.merchantProfile?.logoUrl}
                                      alt=""
                                      className="w-full h-full object-cover"
                                    />
                                  ) : (
                                    <AntAvatar
                                      firstname={user.merchantProfile?.companyName || ""}
                                      height="54px"
                                      width="54px"
                                      fontSize="20px"
                                      color="#D9D9D9"
                                    />
                                  )
                                }
                              </div>

                              <div className="flex flex-col gap-1">
                                <p className="text-[16px] text-white font-semibold">
                                  {user.merchantProfile?.companyName}
                                </p>

                                <p className="text-[12px] text-[#777] ">
                                  {user.merchantProfile?.username}
                                </p>
                              </div>
                            </div>

                            <img src={HouseIcon} alt="" width={15} height={15} />
                          </div>
                        }
                      </>
                    ))}

                    {hasMoreResults && (
                      <button
                      className="mt-4 text-white mb-10 bg-blue-600 px-4 py-2 rounded"
                      onClick={loadMore}>
                        Load More
                      </button>
                    )}
                  </div>
                ) : (
                  <div>
                    <RecentBeneficiaries
                      variables={{
                        offset: 0,
                        limit: 5,
                      }}
                    >
                      {({ users, loading }) => (
                        <div className="flex flex-col mt-8 gap-3 px-[1rem] ">
                          {!loading && users.length === 0 && (
                            <div className="text-white text-center mt-8">
                              No Recent beneficiaries.
                            </div>
                          )}
                          <p className="text-white text-[18px] text-left">
                            Recent Beneficiaries
                          </p>

                          {users.map((user) => (
                            <React.Fragment key={user.id}>
                              {results.map((user) => (
                                <>
                                  {user.__typename === "CustomerPWA" && (
                                    <div
                                      onClick={() =>
                                        navigate(
                                          `${ROUTES.VIEW_SEND_INFO_DETAILS}?user=${user.id}`
                                        )
                                      }
                                      className="flex w-full mt-3 items-center border-[#7777] justify-between gap-3 pb-4 border-b-2 cursor-pointer"
                                    >
                                      <div className="flex items-center gap-4">
                                        <AntAvatar
                                          firstname={`${user.firstname}`}
                                          lastname={`${user.lastname}`}
                                          height="54px"
                                          width="54px"
                                          fontSize="20px"
                                          color="#D9D9D9"
                                        />
                                        <div className="flex flex-col">
                                          <p className="text-[16px] text-white font-semibold">
                                            {user.firstname} {user.lastname}
                                          </p>
                                          <p className="text-[13px] text-[#777] ">
                                            {user.username}
                                          </p>
                                        </div>
                                      </div>
                                      <img
                                        src={PersonIcon}
                                        alt="debit"
                                        width={15}
                                        height={15}
                                      />
                                    </div>
                                  )}

                                  {user.__typename === "AdminPWA" && (
                                    <div
                                      onClick={() =>
                                        navigate(
                                          `${ROUTES.VIEW_SEND_INFO_DETAILS}?user=${user.id}`
                                        )
                                      }
                                      className="flex w-full mt-3 items-center border-[#7777] justify-between gap-3 pb-4 border-b-2 cursor-pointer"
                                    >
                                      <div className="flex items-center gap-4">
                                        {user.merchantProfile?.logoUrl ? (
                                          <img
                                            src={user.merchantProfile?.logoUrl}
                                            alt="chicken republic"
                                            width={54}
                                            height={54}
                                            className="rounded-full"
                                          />
                                        ) : (
                                          <AntAvatar
                                            firstname={`${user.merchantProfile?.companyName}`}
                                            height="54px"
                                            width="54px"
                                            fontSize="20px"
                                            color="#D9D9D9"
                                          />
                                        )}
                                        <div className="flex flex-col">
                                          <p className="text-[16px] text-white font-semibold">
                                            {user.merchantProfile?.companyName}
                                          </p>
                                          <p className="text-[13px] text-[#777] ">
                                            {user.merchantProfile?.username}
                                          </p>
                                        </div>
                                      </div>
                                      <img
                                        src={PersonIcon}
                                        alt="debit"
                                        width={15}
                                        height={15}
                                      />
                                    </div>
                                  )}
                                </>
                              ))}
                            </React.Fragment>
                          ))}
                        </div>
                      )}
                    </RecentBeneficiaries>
                  </div>
                )}
              </>
            )}
          </SearchUser>
        </div>
      </div>
    </TemplateSub>
  );
};
